const CONTEXT = 'localization';
const SUB_GROUP = 'website_actions';
const OUT_OF_SESSION = false;

const BASE_PARAMS = {
    sub_group: SUB_GROUP,
    out_of_session: OUT_OF_SESSION,
    entity_context: {
        name: CONTEXT
    },
    domain: {
        name: CONTEXT
    }
};

module.exports = {
    BASE_PARAMS
};
